// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2ewVw","calendarButtons":"ClockData_calendarButtons__1tmsc"};